import React, { useEffect, useRef } from 'react';
import './css/style.css'
import './css/login.css'
import './css/front.css'
import './css/font-awesome.css'
import './css/loader.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ExchCricket } from './Components/ExchCricket';
import { EventGame } from './Components/EventGame';
import { CommonNav } from './Components/CommonNav';
import { useSelector } from 'react-redux';
import { LoginModal } from './Components/LoginModal';
import { CommonHeader } from './Components/CommonHeader';
import { Protected } from './Components/Protected';
import { DecryptOrderFunction, EncryptOrderFun } from './features/CryptoJsService';
import { commonUriAll } from './CommonUrlList/CommonUrlList';
import { HistoryReport } from './Components/HistoryReport';
import { AllHistory } from './Components/AllHistory';
import { FancyExtra } from './Components/FancyExtra';
import { TradeMarket } from './Components/TradeMarket';
import { TradeMarket2 } from './Components/TradeMarket2';
import MasterHistory from './Components/HistoryData';

function App() {
  const balanceRef = useRef()
  const loginModal = useSelector(state => state.modalState.loginModal)
  const navigate = useNavigate()
  const sessionData = JSON.parse(sessionStorage.getItem('userData') || '{}')
  const getBalanceData = async () => {
    getBalance(sessionData.token).then((data) => {
      if (data) {
        if (data.status !== 'success' && data.stUserName !== "FOXDEMO3") {
          logOut()
        }
        if (data.data.blLock) {
          logOut()
        }
      }
      balanceRef.current = setTimeout(() => {
        getBalanceData()
      }, 5000);
    })
  }
  const getBalance = async (token) => {
    const res = await fetch("https://postg.9xxbet.com/api/v1/users/balance", {
      method: "GET",
      headers: {
        authorization: "Bearer " + token
      }
    })

    const resData = await res.json()
    return resData
  }

  const logOut = () => {
    sessionStorage.clear()
    localStorage.clear()
    navigate('/')
    navigate(0)
  }
  useEffect(() => {
    if (sessionData.isLogin) {
      getBalance(sessionData.token).then((data) => {
        if (data) {
          if (data.status !== 'success' && data.stUserName !== "FOXDEMO3") {
            logOut()
          }
          if (data.data.blLock) {
            logOut()
          }
        }
      })
      balanceRef.current = setTimeout(() => {
        getBalanceData()
      }, 5000);
    }
  }, []);

  return (
    <div className="App">
      <CommonHeader />
      {/* <Navbar /> */}
      {/* <CommonNav /> */}
      <Routes>
        {/* <Route path='/' element={<Home />} /> */}
        {/* <Route path='/script' element={<Cricket />} /> */}
        {/* <Route path='/horse' element={<Horse />} /> */}
        {/* <Route path='/fancy' element={<Fancy />} /> */}
        {/* <Route path='/home' element={<Protected><ExchCricket /></Protected>} /> */}
        <Route path='/' element={<Protected><TradeMarket /></Protected>} />
        <Route path='/history' element={<Protected><MasterHistory /></Protected>} />
        {/* <Route path='/trades2' element={<Protected><TradeMarket2 /></Protected>} />
        <Route path='/sports/event' element={<Protected><EventGame /></Protected>} />
        <Route path='/history' element={<Protected><HistoryReport /></Protected>} />
        <Route path='/fullhistory' element={<Protected><AllHistory /></Protected>} />
        <Route path='/fancy' element={<Protected><FancyExtra /></Protected>} /> */}
      </Routes>
      <ToastContainer></ToastContainer>
      {
        loginModal && <LoginModal />
      }
    </div>
  );
}

export default App;